import './synchro-view.scss'

import { faCalendarAlt, faCaretDown, faCaretRight, faCircleNotch, faStopwatch, faSyncAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import { DataSynchronisationStatus } from '@skinsoft/types';
import { formatDateFromNow, formatDuration } from '@skinsoft/utils';
import { DataStore } from '@skinsoft/data-store'

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { OnlineStatusIndicator } from '@skinsoft/offline-mode/src/components/online-status-indicator';

@Component({
    components: {
        sOnlineStatusIndicator: OnlineStatusIndicator
    },
    props: ['dataStore', 'title'],
    template: require('./synchro-view.html')
})
export class SynchroView extends ReactiveVue {

    public dataStore: DataStore<any>;
    public title: string;

    private syncing: boolean = false;

    // Icons
    private syncIcon = faSyncAlt;
    private durationIcon = faStopwatch;
    private lastDateIcon = faCalendarAlt;
    private loadingIcon = faCircleNotch;
    private crossIcon = faTimes;
    private rightArrow = faCaretRight;
    private downArrow = faCaretDown;

    private progressBarVariant: string = "success";
    private collapsed: boolean = true;

    public mounted() {
        switch (this.dataStore.lastSyncStats?.lastSynchroStatus) {
            case DataSynchronisationStatus.SUCCESS:
                this.progressBarVariant = "success"
                break;
            default:
                this.progressBarVariant = "danger"
                break;
        }

        this.syncing = this.dataStore.isSyncing;
    }

    private synchronize() {
        if (this.dataStore.lastSyncStats) {
            this.dataStore.lastSyncStats.lastSynchroStatus = DataSynchronisationStatus.SUCCESS;
        }
        this.progressBarVariant = "success";
        this.syncing = true;
        this.dataStore.synchronize(0, true);
    }

    private abortSynchronisation() {
        this.dataStore.abortSynchronisation();
        this.progressBarVariant = "danger";
        this.syncing = false;
    }

    private get synchroNbMax() {
        return this.dataStore.lastSyncStats?.maxNbToSynchronize;
    }

    private get synchroNbCurrent() {
        return this.dataStore.lastSyncStats?.currentNbSychronized;
    }

    private get lastSynchroDuration() {
        if (this.dataStore.lastSyncStats?.lastSynchroDuration) {
            return formatDuration(this.dataStore.lastSyncStats?.lastSynchroDuration,
                this.$t('time.minutes'), this.$t('time.seconds'))
        }
    }

    private get lastSynchroDate() {
        return formatDateFromNow(this.dataStore.lastSyncStats?.lastSynchroDate, this.$i18n.locale);
    }

    private get lastSynchroStatus() {
        return this.dataStore.lastSyncStats?.lastSynchroStatus ?? DataSynchronisationStatus.NONE;
    }

    @Watch('dataStore.isSyncing')
    private onSyncStateChange() {
        this.syncing = this.dataStore.isSyncing;
        if (this.dataStore.lastSyncStats.lastSynchroStatus !== DataSynchronisationStatus.SUCCESS) {
            this.progressBarVariant = "danger";
        } else {
            this.progressBarVariant = "success";
        }
    }

}